var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { on: { change: _vm.logChangeData } }, [
    _c("div", { staticClass: "setting_content" }, [
      _c("div", { staticClass: "setting_content_main" }, [
        _c("h2", { staticClass: "setting_content_title" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.policyLabelsProperties.TAB_HEADER) +
              "\n      "
          )
        ]),
        _c("div", { staticClass: "setting_unit" }, [
          _c("p", { staticClass: "setting_unit_title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.policyLabelsProperties.POLICY_HEADER) +
                "\n        "
            )
          ]),
          _c("p", { staticClass: "setting_unit_explain" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.policyLabelsProperties.POLICY_SUB_HEADER) +
                "\n        "
            )
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.policyLabelsProperties.POLICY_INPUT_TITLE) +
                  "\n          "
              )
            ]),
            _c("div", { staticClass: "setting_unit_form" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.draftPolicy.content,
                    expression: "draftPolicy.content"
                  }
                ],
                staticClass: "setting_form_textarea",
                attrs: {
                  placeholder: _vm.policyLabelsProperties.POLICY_PLACEHOLDER
                },
                domProps: { value: _vm.draftPolicy.content },
                on: {
                  change: function($event) {
                    return _vm.validatePolicy()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.draftPolicy, "content", $event.target.value)
                  }
                }
              }),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.lengthErrorPolicy,
                      expression: "lengthErrorPolicy"
                    }
                  ],
                  staticClass: "error-message"
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.policySettingsProperties.POLICY_MAX_LENGTH) +
                      "\n              " +
                      _vm._s(_vm.errorProperties.MAX_LENGTH_CHARACTER_MESSAGE) +
                      "\n            "
                  )
                ]
              )
            ])
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.policyLabelsProperties.POLICY_ENABLE_CHECKBOX) +
                  "\n          "
              )
            ]),
            _c("div", { staticClass: "setting_unit_form" }, [
              _c("div", { staticClass: "setting_form_checkbox" }, [
                _c("label", { staticClass: "setting_form_checkbox_label" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.policy.isEnabledPolicy,
                        expression: "policy.isEnabledPolicy"
                      }
                    ],
                    attrs: { type: "checkbox", value: "true" },
                    domProps: {
                      checked: Array.isArray(_vm.policy.isEnabledPolicy)
                        ? _vm._i(_vm.policy.isEnabledPolicy, "true") > -1
                        : _vm.policy.isEnabledPolicy
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.policy.isEnabledPolicy,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "true",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.policy,
                                  "isEnabledPolicy",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.policy,
                                  "isEnabledPolicy",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.policy, "isEnabledPolicy", $$c)
                          }
                        },
                        function($event) {
                          return _vm.checkEnabledPolicy()
                        }
                      ]
                    }
                  }),
                  _c("span", { staticClass: "setting_form_checkbox_text" }, [
                    _vm._v(
                      "\n                  " +
                        _vm._s(
                          _vm.policyLabelsProperties.POLICY_ENABLE_OPTION
                        ) +
                        "\n                "
                    )
                  ])
                ])
              ])
            ])
          ])
        ]),
        _c("div", { staticClass: "setting_unit" }, [
          _c("p", { staticClass: "setting_unit_title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.policyLabelsProperties.LINK_HEADER) +
                "\n        "
            )
          ]),
          _c("p", { staticClass: "setting_unit_explain" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.policyLabelsProperties.LINK_SUB_HEADER) +
                "\n        "
            )
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.policyLabelsProperties.URL_INPUT_TITLE) +
                  "\n          "
              )
            ]),
            _c("div", { staticClass: "setting_unit_form" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.draftPolicy.url,
                    expression: "draftPolicy.url"
                  }
                ],
                staticClass: "setting_form_text",
                attrs: {
                  type: "text",
                  placeholder: _vm.policyLabelsProperties.URL_PLACEHOLDER
                },
                domProps: { value: _vm.draftPolicy.url },
                on: {
                  change: function($event) {
                    return _vm.validateInputUrl()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.draftPolicy, "url", $event.target.value)
                  }
                }
              }),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.lengthErrorUrl,
                      expression: "lengthErrorUrl"
                    }
                  ],
                  staticClass: "error-message"
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.policySettingsProperties.URL_MAXLENGTH) +
                      "\n              " +
                      _vm._s(_vm.errorProperties.MAX_LENGTH_CHARACTER_MESSAGE) +
                      "\n            "
                  )
                ]
              ),
              _vm.formatUrlError
                ? _c("p", { staticClass: "error-message" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.errorProperties.WRONG_URL_FORMAT) +
                        "\n            "
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.policyLabelsProperties.LINK_INPUT_TITLE) +
                  "\n          "
              )
            ]),
            _c("div", { staticClass: "setting_unit_form" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.draftPolicy.textLink,
                    expression: "draftPolicy.textLink"
                  }
                ],
                staticClass: "setting_form_text",
                attrs: {
                  type: "text",
                  placeholder: _vm.policyLabelsProperties.LINK_PLACEHOLDER
                },
                domProps: { value: _vm.draftPolicy.textLink },
                on: {
                  change: function($event) {
                    return _vm.validateInputTextLink()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.draftPolicy, "textLink", $event.target.value)
                  }
                }
              }),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.lengthErrorTextLink,
                      expression: "lengthErrorTextLink"
                    }
                  ],
                  staticClass: "error-message"
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.policySettingsProperties.LINK_MAX_LENGTH) +
                      "\n              " +
                      _vm._s(_vm.errorProperties.MAX_LENGTH_CHARACTER_MESSAGE) +
                      "\n            "
                  )
                ]
              )
            ])
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.policyLabelsProperties.POLICY_ENABLE_CHECKBOX) +
                  "\n          "
              )
            ]),
            _c("div", { staticClass: "setting_unit_form" }, [
              _c("div", { staticClass: "setting_form_checkbox" }, [
                _c("label", { staticClass: "setting_form_checkbox_label" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.policy.isEnabledUrl,
                        expression: "policy.isEnabledUrl"
                      }
                    ],
                    attrs: { type: "checkbox", value: "true" },
                    domProps: {
                      checked: Array.isArray(_vm.policy.isEnabledUrl)
                        ? _vm._i(_vm.policy.isEnabledUrl, "true") > -1
                        : _vm.policy.isEnabledUrl
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.policy.isEnabledUrl,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "true",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.policy,
                                  "isEnabledUrl",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.policy,
                                  "isEnabledUrl",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.policy, "isEnabledUrl", $$c)
                          }
                        },
                        function($event) {
                          return _vm.checkEnabledUrl()
                        }
                      ]
                    }
                  }),
                  _c("span", { staticClass: "setting_form_checkbox_text" }, [
                    _vm._v(
                      "\n                  " +
                        _vm._s(
                          _vm.policyLabelsProperties.POLICY_ENABLE_OPTION
                        ) +
                        "\n                "
                    )
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }